/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Color_YellowInputs */

const en_orders_review_color_yellow = /** @type {(inputs: Orders_Review_Color_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yellow`)
};

const es_orders_review_color_yellow = /** @type {(inputs: Orders_Review_Color_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amarillo`)
};

/**
* | output |
* | --- |
* | "Yellow" |
*
* @param {Orders_Review_Color_YellowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_color_yellow = /** @type {((inputs?: Orders_Review_Color_YellowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Color_YellowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_color_yellow(inputs)
	return es_orders_review_color_yellow(inputs)
});